import { isObject, isArray, isUndefined, uniq, uniqBy } from "lodash";

function toArray(object) {
  return isArray(object) ? object : Object.values(object);
}

export function unique(collection, callback) {
  collection = isObject(collection) ? toArray(collection) : collection;

  if (!isArray(collection)) {
    return collection;
  }

  return isUndefined(callback)
    ? //if it's kind of primitive array
      uniq(collection)
    : //else compare with equals
      uniqBy(collection, callback);
}
